import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SectionTitleComponent } from './section-title/section-title.component';
import { FooterComponent } from './footer/footer.component';
import { FileDropDirective } from './custom-directives/file-drop.directive';
import { TooltipDisableDirective } from './custom-directives/tooltip.directive';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { GlobalErrorComponent } from './global-error/global-error.component';
import { SearchComponent } from './search/search.component';
import { ProgressListComponent } from './progress-list/progress-list.component';
import { HasActionClaimDirective } from './action-claim/has-action-claim.directive';
import { MatRippleDirective } from './custom-directives/matRipple.directive';
import { DescriptionOverlayComponent } from './description-overlay/description-overlay.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { YearPickerComponent } from './year-picker/year-picker.component';
import { AutoCompleteComponent } from './autocomplete/autocomplete.component';
import { UserInformationOverlayComponent } from './user-information-overlay/user-information-overlay.component';
import { NoDocumentFoundComponent } from './no-document-found/no-document-found.component';

@NgModule({
    imports: [
        CommonModule, MaterialModule, FormsModule, RouterModule, ReactiveFormsModule, DragDropModule, TranslateModule, MatDatepickerModule, TooltipDisableDirective, NoDocumentFoundComponent,
        HasActionClaimDirective, SectionTitleComponent, DescriptionOverlayComponent, YearPickerComponent,
        FooterComponent, GlobalErrorComponent,
        FileDropDirective, MultiSelectDropdownComponent, AutoCompleteComponent,
        SearchComponent, ProgressListComponent, MatRippleDirective, UserInformationOverlayComponent
    ],
    exports: [HasActionClaimDirective, SectionTitleComponent,
        FooterComponent, FileDropDirective, GlobalErrorComponent, MultiSelectDropdownComponent, DescriptionOverlayComponent,
        SearchComponent, ProgressListComponent, TooltipDisableDirective, MatRippleDirective, AutoCompleteComponent, UserInformationOverlayComponent, NoDocumentFoundComponent],
})
export class SharedModule { }
